/**
 * some values either through redux form or bad api design come
 * back as string "true" or "false", this will convert that into
 * actual booleans, and if the value of the string is neither 'true'
 * or 'false' we just return the original string unmodified
 * @param {string} value
 * @returns {bool, string}
 */
 const parseBool = value =>
 value === 'true' ? true : value === 'false' ? false : value

export default parseBool
